export const MARKET_DATA_API_NAMES = {
  QuoteBatchGet3: `QuoteBatchGet3`,
  TheScreenerGetAll1: `TheScreenerGetAll1`,
  MorningstarQuantitativeSummaryGet2: `MorningstarQuantitativeSummaryGet2`,
  ExchangeRateGet1: `ExchangeRateGet1`
};
